import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import type { DeviceManufacturer } from '@devices';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ManufacturerService {
  private http = inject(HttpClient);

  getManufacturers(): Observable<DeviceManufacturer[]> {
    return this.http
      .get<{ data: DeviceManufacturer[]; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-makers`)
      .pipe(map(response => response.data));
  }

  addNewManufacturer(data: Pick<DeviceManufacturer, 'name'>): Observable<DeviceManufacturer> {
    return this.http
      .post<{ data: DeviceManufacturer; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-makers`, data)
      .pipe(map(response => response.data));
  }

  editManufacturerName(id: string, data: { name: string; }) {
    return this.http
      .patch<{ data: DeviceManufacturer; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-makers/${id}`, data)
      .pipe(map(response => response.data));
  }

  deleteManufacturer(id: string) {
    return this.http
      .delete<{ data: DeviceManufacturer; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/device-makers/${id}`);
  }
}
